export default __webpack_public_path__ + "static/media/p20.afc967dd.jpeg";